import iot from "../../images/case-studies/iot-hero.webp";
import ai from "../../images/case-studies/ai-hero.webp";
import cloud from "../../images/case-studies/cloud-hero.webp";
import aws from "../../images/case-studies/devops-engineer-hero.webp";
import automation from "../../images/case-studies/automationtest-engineer-hero.webp";
import ml from "../../images/case-studies/machinelearning-engineer-hero.webp";
import blockchain from "../../images/case-studies/blockchain-developer-hero.webp";
import crossplatform from "../../images/case-studies/devops-engineer-hero.webp";
import android from "../../images/case-studies/android-hero.webp";

export const caseStudyImages = {
    hero: {
        iot: iot,
        ai: ai,
        cloud: cloud,
        devops: aws,
        testing: automation,
        ml: ml,
        blockchain: blockchain,
        crossplatform: crossplatform,
        androidapp: android
    }
};